import Tools from './../components/tools';

export default class Page {
  constructor() {
    // Page
  }
}